/* istanbul ignore file */
import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import { OfferingsPage, PolicyDetailsPage, LocationsPage, SuccessPage, DeclarationPage, RiskAnalysisPage, PolicyInfoPage } from 'premier-capability-policyjob-react';
import CodegenWizard from './CodegenWizard';
import { CodegenContext } from './components/CodegenContext';
import FoodTruckPage from './pages/FoodTruck/FoodTruckPage';
import QuotePage from './pages/Quote/QuotePage';
import LiabilityCoveragesPage from './pages/LiabilityCoverages/LiabilityCoveragesPage';
import PropertyPage from './pages/Property/PropertyPage';
import PropertyCoveragesPage from './pages/PropertyCoverages/PropertyCoveragesPage';

setComponentMapOverrides(
    {
        // wizard pages
        PremierOfferingsPage : { component: 'PremierOfferingsPage'},
        PremierLEPolicyDetailsPage: { component: 'PremierLEPolicyDetailsPage' },
        PremierLELocationsPage : { component: 'PremierLELocationsPage'},
        PremierLEFoodTruckPage : { component: 'PremierLEFoodTruckPage' },
        PremierLELiabilityCoveragesPage: { component: 'PremierLELiabilityCoveragesPage' },
        PremierLEPropertyPage: { component: 'PremierLEPropertyPage' },
        PremierLEPropertyCoveragesPage: { component: 'PremierLEPropertyCoveragesPage' },
        PremierLERiskAnalysisPage: { component: 'PremierLERiskAnalysisPage' },
        PremierLEQuotePage: { component: 'PremierLEQuotePage' },
        PremierLEPolicyInfoPage: { component: 'PremierLEPolicyInfoPage' },
        PremierLEDeclarationPage: { component: 'PremierLEDeclarationPage' },
        PremierLESuccessPage: { component: 'PremierLESuccessPage' },
    },
    {
        // wizard pages
        PremierOfferingsPage: OfferingsPage,
        PremierLEPolicyDetailsPage: PolicyDetailsPage,
        PremierLELocationsPage: LocationsPage,
        PremierLEFoodTruckPage: FoodTruckPage,
        PremierLELiabilityCoveragesPage: LiabilityCoveragesPage,
        PremierLEPropertyPage: PropertyPage,
        PremierLEPropertyCoveragesPage: PropertyCoveragesPage,    
        PremierLERiskAnalysisPage: RiskAnalysisPage,
        PremierLEQuotePage: QuotePage,
        PremierLEPolicyInfoPage: PolicyInfoPage,
        PremierLEDeclarationPage: DeclarationPage,
        PremierLESuccessPage: SuccessPage,
    }
);
// eslint-disable-next-line import/prefer-default-export
export { CodegenWizard, CodegenContext };